import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import Lenis from "lenis";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import SocialRail from "./components/SocialRail";
import { CartProvider } from "./context/CartContext";
import Home from "./pages/Home";
import ShopAll from "./pages/ShopAll";
import About from "./pages/About";
import Contact from "./pages/Contact";
import ProductDetail from "./pages/ProductDetail";
import { Privacy, Terms } from "./pages/Legal";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function Shell() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    let raf;
    const tick = (time) => { lenis.raf(time); raf = requestAnimationFrame(tick); };
    raf = requestAnimationFrame(tick);
    const onClick = (e) => {
      const a = e.target.closest?.('a[href^="#"]');
      if (a) {
        const id = a.getAttribute("href");
        const el = id && id.length > 1 ? document.querySelector(id) : null;
        if (el) { e.preventDefault(); lenis.scrollTo(el, { offset: -60 }); }
      }
    };
    document.addEventListener("click", onClick);
    return () => { cancelAnimationFrame(raf); document.removeEventListener("click", onClick); lenis.destroy(); };
  }, []);

  useEffect(() => { const t = setTimeout(() => setLoaded(true), 60); return () => clearTimeout(t); }, []);

  return (
    <div className="site-shell">
      <div className="grain" aria-hidden="true" />
      <AnimatePresence>
        {!loaded && (
          <motion.div className="curtain" initial={{ y: 0 }} exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.83, 0, 0.17, 1] }} aria-hidden="true">
            <span>Bhoomiza</span>
          </motion.div>
        )}
      </AnimatePresence>

      <Header />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<ShopAll />} />
          <Route path="/shop/:category" element={<ShopAll />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
      <CartDrawer />
      <SocialRail />
      <Toaster position="bottom-center" toastOptions={{ className: "bhoomiza-toast" }} />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Shell />
      </CartProvider>
    </BrowserRouter>
  );
}
